import * as THREE from "three";
import { useEffect } from "react";
import { useThree } from "@react-three/fiber";

export default function SeatPracticalLights({
  lightFile, // imported JSON
  enableBase = true,
  enableAccent = false,
  enableCocktail = false,
  parentRef = null, // optional seat root
}) {
  const { scene } = useThree();

  useEffect(() => {
    if (!lightFile) return;

    const { defaults, lights } = lightFile;

    const parent = parentRef?.current || scene;

    const createdLights = [];

    const activeGroups = [];
    if (enableBase) activeGroups.push("base");
    if (enableAccent) activeGroups.push("accent");
    if (enableCocktail) activeGroups.push("cocktail");

    lights
      .filter((def) => activeGroups.includes(def.group))
      .forEach((def) => {
        const light = new THREE.RectAreaLight(
          def.color ?? defaults.color,
          def.intensity ?? defaults.intensity,
          def.width,
          def.height,
        );

        const position = new THREE.Vector3(...def.position);
        const direction = new THREE.Vector3(...def.direction).normalize();

        light.position.copy(position);
        light.lookAt(position.clone().add(direction));

        parent.add(light);
        createdLights.push(light);
      });

    return () => {
      createdLights.forEach((l) => parent.remove(l));
    };
  }, [scene, lightFile, enableBase, enableAccent, enableCocktail, parentRef]);

  return null;
}
